export class VerifyOtpResponse {

  isVerified: boolean;
  email: string;
  phone: string;

  constructor(isVerified: boolean) {
    this.isVerified = isVerified
  }
}
